import * as Sentry from '@sentry/react';
import { useRef } from 'react';

import { useDynamicActionMutation } from '@mutations/AppMutations';

import { NavigateOptions, useRouter } from '@router/index';

export interface DynamicActionProperties {
  to?: string;
  action?: string;
  payload?: Record<string, any>;
}

export const useDynamicAction = () => {
  const { navigate } = useRouter();
  const { isSubmitting, dynamicActionAsync } = useDynamicActionMutation();
  const isSubmittingRef = useRef(false);

  const handleDynamicAction = async (
    actionProperties: DynamicActionProperties = {},
    navigateOptions?: NavigateOptions,
  ) => {
    if (isSubmittingRef.current) {
      return;
    }

    try {
      isSubmittingRef.current = true;

      if (actionProperties.action) {
        const dynamicActionResponse = await dynamicActionAsync({
          action: actionProperties.action,
          payload: actionProperties.payload,
        });

        if (dynamicActionResponse?.to) {
          navigate(dynamicActionResponse.to, navigateOptions);
        }

        return;
      }

      if (actionProperties.to) {
        navigate(actionProperties.to, navigateOptions);
      }
    } catch (error) {
      Sentry.captureException(error, { data: actionProperties });
    } finally {
      isSubmittingRef.current = false;
    }
  };

  return { isSubmittingDynamicAction: isSubmitting, handleDynamicAction };
};
